import moment from "moment-timezone"
const DEFAULT_LOCALE = 'en_US';
const DEFAULT_FORMAT_DATE = 'YYYY-MM-DD'
export const DEFAULT_TIME_ZONE = 'America/Curacao';
export const DEFAULT_FORMAT_DATE_TIME = 'YYYY-MM-DD HH:mm:ss'
export const DATE_MONTH_YEAR_FORMAT = 'DD/MM/YYYY HH:mm:ss'

export const setDefaultTimeZone = (tz) => {
    tz ? moment.tz.setDefault(tz) : moment.tz.setDefault();
}

export const getGuessTimeZone = function () {
    return moment.tz.guess()
}
/*
    * export const getNowString() -> "2019-02-21 04:39:07"
    * export const getNowString("DD//MM/YYYY") -> "21/02/2019"
   */
export const getNowString = function (tz, format) {
    let formatDate = format ? format : DEFAULT_FORMAT_DATE
    let timeZone = tz ? tz : DEFAULT_TIME_ZONE
    return moment.tz(timeZone).format(formatDate)
}
/*
 * export const getNow() -> Thu Feb 21 2019 05:07:21
*/
export const getNow = function (tz) {
    let timeZone = tz ? tz : DEFAULT_TIME_ZONE
    return moment().tz(timeZone)
}

export const getMoment = function (date) {
    return date ? moment(date) : moment()
}

export const getMomentTZ = function (date, timeZone) {
    return date ? moment.tz(date, timeZone) : moment().tz(timeZone);
}

export const getFirstDayOfMonth = function (tz, format) {
    let formatDate = format ? format : DEFAULT_FORMAT_DATE
    let timeZone = tz ? tz : DEFAULT_TIME_ZONE
    return moment().tz(timeZone).startOf('month').format(formatDate)
}

export const getMomentBeforeNow = function (nYear, nMonth, nDay, tz) {
    let year = nYear ? nYear : 0
    let month = nMonth ? nMonth : 0
    let days = nDay ? nDay : 0
    let timeZone = tz ? tz : DEFAULT_TIME_ZONE
    return moment().tz(timeZone).subtract(year, 'year').subtract(month, 'month').subtract(days, 'days')
}

export const customFormatYMD = function (date, format) {
    let formatDate = format ? format : DEFAULT_FORMAT_DATE
    return date ? getMoment(date).format(formatDate) : getMoment().format(formatDate)
}
export const customFormatTz = function (date, format, tz) {
    let formatDate = format ? format : DEFAULT_FORMAT_DATE
    let timeZone = tz ? tz : DEFAULT_TIME_ZONE
    return date ? getMoment(date).tz(timeZone).format(formatDate) : moment().format(formatDate) 
}

export const parseUserTimeZoneToServerTimeZone = function (date) {
    return date ? moment(date).tz(DEFAULT_TIME_ZONE).format(DATE_MONTH_YEAR_FORMAT) : moment().tz(DEFAULT_TIME_ZONE).format(DATE_MONTH_YEAR_FORMAT);
}



// WEBPACK FOOTER //
// ./src/app/common/DateUtils.js